// The fixed line under the question box (wording in content/about.ts).

import { ABOUT_LINK_TEXT, CHAT_DISCLAIMER } from "../content/about.js";
import { linkTo } from "../router.js";

export function ComposerNote() {
  return (
    <p className="composer-note">
      {CHAT_DISCLAIMER}{" "}
      <a href="/about" onClick={linkTo("/about")}>
        {ABOUT_LINK_TEXT}
      </a>
    </p>
  );
}
